var taskOperationTypes = [
  {
    name: 'CreateNewTask',
    label: 'ثبت سفارش جدید توسط مسئول برنامه‌ریزی تولید',
    value: 0
  },

  {
    name: 'AssigningToMaterialWarehouseUnit',
    label: 'ارجاع سفارش به انبار مواد اولیه',
    value: 1
  },

  {
    name: 'AssigningToImpregnationUnitManager',
    label: 'ارجاع به مدیر واحد آغشته سازی',
    value: 2
  },
  {
    name: 'AssigningToImpregnationUnit',
    label: 'ارجاع به واحد آغشته سازی',
    value: 3
  },
  {
    name: 'AssigningToImpregnationUnitNextShift',
    label: 'ارجاع به شیفت بعدی واحد آغشته سازی',
    value: 4
  },
  {
    name: 'InProgressInImpregnationUnit',
    label: 'در حال انجام در واحد آغشته سازی',
    value: 5
  },

  {
    name: 'AssigningToPressUnitManager',
    label: 'ارجاع به مدیر واحد پرس',
    value: 6
  },
  { name: 'AssigningToPressUnit', label: 'ارجاع به واحد پرس', value: 7 },
  {
    name: 'AssigningToPressUnitNextShift',
    label: 'انجام بخشی از سفارش و ارجاع به شیفت بعدی واحد پرس',
    value: 8
  },
  { name: 'InProgressInPressUnit', label: 'شروع سفارش در واحد پرس', value: 9 },

  {
    name: 'AssigningToCuttingUnitManager',
    'ارجاع به مدیر واحد برش': '',
    value: 10
  },
  { name: 'AssigningToCuttingUnit', label: 'ارجاع به واحد برش', value: 11 },
  {
    name: 'AssigningToCuttingUnitNextShift',
    label: 'انجام بخشی از سفارش و ارجاع به شیفت بعدی واحد برش',
    value: 12
  },
  {
    name: 'InProgressInCuttingUnit',
    label: 'شروع سفارش در واحد برش',
    value: 13
  },

  {
    name: 'AssigningToClickUnitManager',
    'ارجاع به مدیر واحد کلیک': '',
    value: 14
  },
  { name: 'AssigningToClickUnit', label: 'ارجاع به واحد کلیک', value: 15 },
  {
    name: 'AssigningToClickUnitNextShift',
    label: 'انجام بخشی از سفارش و ارجاع به شیفت بعدی واحد کلیک',
    value: 16
  },
  {
    name: 'InProgressInClickUnit',
    label: 'شروع سفارش در واحد کلیک',
    value: 17
  },

  { name: 'AssigningToWarehouse', label: 'ارجاع به انبار نهایی', value: 18 },
  {
    name: 'ImportProductsToWarehouseAndFinishTask',
    label: 'ورود کالاها به انبار محصولات و اتمام سفارش',
    value: 19
  },

  {
    name: 'AssigningToCuttingUnitAutomatically',
    label: 'ارجاع اتوماتیک سفارش از واحد پرس به واحد برش',
    value: 20
  },
  {
    name: 'AssigningToClickUnitAutomatically',
    label: 'ارجاع اتوماتیک سفارش از واحد برش به واحد کلیک',
    value: 21
  },

  {
    name: 'FinishingTaskInPressUnit',
    label: 'اتمام سفارش در واحد پرس',
    value: 22
  },
  {
    name: 'FinishingTaskInCuttingUnit',
    label: 'اتمام سفارش در واحد برش',
    value: 23
  },
  {
    name: 'FinishingTaskInClickUnitAssigningToWarehouse',
    label: 'اتمام سفارش در واحد کلیک و ارجاع به مسئول انبار',
    value: 24
  },

  { name: 'ChangeThePressUnit', label: 'تعویض دستگاه پرس', value: 25 },
  {
    name: 'MaterialReplacementRequest',
    label: 'درخواست جایگزینی مواد اولیه',
    value: 26
  },
  { name: 'ReplacingMaterials', label: 'جایگزین کردن مواد اولیه', value: 27 }
]

export default taskOperationTypes
